import { INPUT_TYPES } from '@shared/tabbed-table/constants';
import { BulkCapacityMatchJobStatus } from 'cargo-chief-commons';

export const LOADS_AUTOMATION_FIELDS = {
	CREATED: 'Created',
	JOB_STATUS: 'Job Status',
	USER: 'User',
	FILE_NAME: 'File Name',
	TOTAL_ROWS: 'Total Rows',
	ROWS_PARSED: 'Rows Parsed',
	ROWS_INSERTED: 'Rows Inserted',
	ROWS_FAILED: 'Rows Failed',
};

export function buildHeaders() {
	return [
		{ dataName: 'select', formattedName: 'select' },
		{ dataName: 'created', formattedName: LOADS_AUTOMATION_FIELDS.CREATED },
		{ dataName: 'jobStatus', formattedName: LOADS_AUTOMATION_FIELDS.JOB_STATUS },
		{ dataName: 'userName', formattedName: LOADS_AUTOMATION_FIELDS.USER },
		{ dataName: 's3FileLocation', formattedName: LOADS_AUTOMATION_FIELDS.FILE_NAME },
		{ dataName: 'totalTasks', formattedName: LOADS_AUTOMATION_FIELDS.TOTAL_ROWS },
		{ dataName: 'tasksParsed', formattedName: LOADS_AUTOMATION_FIELDS.ROWS_PARSED },
		{ dataName: 'tasksInserted', formattedName: LOADS_AUTOMATION_FIELDS.ROWS_INSERTED },
		{ dataName: 'tasksFailed', formattedName: LOADS_AUTOMATION_FIELDS.ROWS_FAILED },
	];
}

export const HEADERS_DATATYPES = [
	'date',
	'string',
	'string',
	'string',
	'number',
	'number',
	'number',
	'number',
];

export const DISPLAYED_COLUMNS = [
	'select',
	'created',
	'jobStatus',
	'userName',
	's3FileLocation',
	'totalTasks',
	'tasksParsed',
	'tasksInserted',
	'tasksFailed',
];

export const SORT_FIELDS = [
	LOADS_AUTOMATION_FIELDS.CREATED,
	LOADS_AUTOMATION_FIELDS.JOB_STATUS,
	LOADS_AUTOMATION_FIELDS.USER,
	LOADS_AUTOMATION_FIELDS.FILE_NAME,
	LOADS_AUTOMATION_FIELDS.TOTAL_ROWS,
	LOADS_AUTOMATION_FIELDS.ROWS_PARSED,
	LOADS_AUTOMATION_FIELDS.ROWS_INSERTED,
	LOADS_AUTOMATION_FIELDS.ROWS_FAILED,
];

export const SORT_FIELD_MAPS = {
	[LOADS_AUTOMATION_FIELDS.CREATED]: 'created',
	[LOADS_AUTOMATION_FIELDS.JOB_STATUS]: 'jobStatus',
	[LOADS_AUTOMATION_FIELDS.USER]: 'userIds',
	[LOADS_AUTOMATION_FIELDS.FILE_NAME]: 's3FileLocation',
	[LOADS_AUTOMATION_FIELDS.TOTAL_ROWS]: 'totalRows',
	[LOADS_AUTOMATION_FIELDS.ROWS_PARSED]: 'rowsParsed',
	[LOADS_AUTOMATION_FIELDS.ROWS_INSERTED]: 'rowsInserted',
	[LOADS_AUTOMATION_FIELDS.ROWS_FAILED]: 'invalidRows',
};

export const FILTER_FIELDS = [
	LOADS_AUTOMATION_FIELDS.CREATED,
	LOADS_AUTOMATION_FIELDS.JOB_STATUS,
	LOADS_AUTOMATION_FIELDS.USER,
	LOADS_AUTOMATION_FIELDS.FILE_NAME,
	LOADS_AUTOMATION_FIELDS.TOTAL_ROWS,
	LOADS_AUTOMATION_FIELDS.ROWS_PARSED,
	LOADS_AUTOMATION_FIELDS.ROWS_INSERTED,
	LOADS_AUTOMATION_FIELDS.ROWS_FAILED,
];

export const BULK_CAPACITY_MATCH_JOBS_STATUS = [
	{
		label: 'Completed',
		type: BulkCapacityMatchJobStatus.COMPLETED,
	},
	{
		label: 'Failed',
		type: BulkCapacityMatchJobStatus.FAILED,
	},
	{
		label: 'New',
		type: BulkCapacityMatchJobStatus.NEW,
	},
	{
		label: 'Notification Pending',
		type: BulkCapacityMatchJobStatus.NOTIFICATION_PENDING,
	},
	{
		label: 'Processed',
		type: BulkCapacityMatchJobStatus.PROCESSED,
	},
	{
		label: 'Processing',
		type: BulkCapacityMatchJobStatus.PROCESSING,
	},
	{
		label: 'Scheduled',
		type: BulkCapacityMatchJobStatus.SCHEDULED,
	},
	{
		label: 'Staged',
		type: BulkCapacityMatchJobStatus.STAGED,
	},
];

export let filterFieldsInputTypeMap: Map<string, string> = new Map<string, string>();
filterFieldsInputTypeMap.set(LOADS_AUTOMATION_FIELDS.CREATED, INPUT_TYPES.DATE);
filterFieldsInputTypeMap.set(LOADS_AUTOMATION_FIELDS.JOB_STATUS, INPUT_TYPES.JOB_STATUS);
filterFieldsInputTypeMap.set(LOADS_AUTOMATION_FIELDS.USER, INPUT_TYPES.USERS_LIST);
